<template>
    <div class="privacy">
  <h2>プライバシーポリシー</h2>
<h3>当サイトに掲載されている広告について</h3>
    <p>当サイトでは、第三者配信の広告サービス（Googleアドセンス、A8.net、Amazonアソシエイト）を利用しています。</p>
    <p>このような広告配信事業者は、ユーザーの興味に応じた商品やサービスの広告を表示するため、当サイトや他サイトへのアクセスに関する情報 『Cookie』(氏名、住所、メール アドレス、電話番号は含まれません) を使用することがあります。</p>
<h3>当サイトが使用しているアクセス解析ツールについて</h3>
    <p>当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。</p>

   <p>このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。</p>

    <p>このトラフィックデータは匿名で収集されており、個人を特定するものではありません。</p>

    <p>この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。</p>
    </div>
</template>

<script>
export default {
    mounted(){
        const title = "プライバシーポリシー｜Flatte"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
    },
}
</script>

<style>
.privacy{
  max-width: 960px;
  margin: auto;
  padding: 0 40px;
}
h2{
    font-weight: bold;
    font-size: 1.5rem;
    margin: 24px 0;
}
h3{
    font-weight: bold;
    font-size: 1.2rem;
    margin: 24px 0;
}
</style>